import React from 'react'
import './accommodation.css'

import AccommodationOptions from './AccommodationOptions'
import AccommodationFilter from './AccommodationFilter'
import BookingDotComLink from '../BookingDotComLink/BookingDotComLink'

const Accommodation = ({id}) => {
  const urls = {
    nerac:
      'http://www.booking.com/searchresults.en-gb.html?label=opensearch-plugin;sid=0033356e42d1e456b5f0f1eea145ac51;checkin_year_month_monthday=2017-09-01;checkout_year_month_monthday=2017-09-03;class_interval=1;dest_id=-1454650;dest_type=city;dtdisc=0;group_adults=2;group_children=0;hlrd=0;hyb_red=0;inac=0;label_click=undef;nha_red=0;no_rooms=1;offset=0;postcard=0;qrhpp=e81a4a5ca473184f3b878114128d067f-city-0;redirected_from_city=0;redirected_from_landmark=0;redirected_from_region=0;review_score_group=empty;room1=A%2CA;sb_price_type=total;score_min=0;si=ai%2Cco%2Cci%2Cre%2Cdi;ss=N%C3%A9rac;ss_all=0;ssb=empty;sshis=0;origin=search;srpos=1',
    barbaste:
      'http://www.booking.com/searchresults.en-gb.html?label=opensearch-plugin&sid=0033356e42d1e456b5f0f1eea145ac51&sb=1&src=searchresults&src_elem=sb&error_url=http%3A%2F%2Fwww.booking.com%2Fsearchresults.en-gb.html%3Flabel%3Dopensearch-plugin%3Bsid%3D0033356e42d1e456b5f0f1eea145ac51%3Bcheckin_year_month_monthday%3D2017-09-01%3Bcheckout_year_month_monthday%3D2017-09-03%3Bclass_interval%3D1%3Bdest_id%3D-1410266%3Bdest_type%3Dcity%3Bdtdisc%3D0%3Bgroup_adults%3D2%3Bgroup_children%3D0%3Bhlrd%3D0%3Bhyb_red%3D0%3Binac%3D0%3Blabel_click%3Dundef%3Bnha_red%3D0%3Bno_rooms%3D1%3Boffset%3D0%3Bpostcard%3D0%3Bredirected_from_city%3D0%3Bredirected_from_landmark%3D0%3Bredirected_from_region%3D0%3Breview_score_group%3Dempty%3Broom1%3DA%252CA%3Bsb_price_type%3Dtotal%3Bscore_min%3D0%3Bsi%3Dai%252Cco%252Cci%252Cre%252Cdi%3Bss%3Dbarbaste%3Bss_all%3D0%3Bssb%3Dempty%3Bsshis%3D0%26%3B&ss=Barbaste&ssne=Barbaste&ssne_untouched=Barbaste&city=-1410266&checkin_monthday=1&checkin_month=9&checkin_year=2017&checkout_monthday=3&checkout_month=9&checkout_year=2017&room1=A%2CA&no_rooms=1&group_adults=2&group_children=0',
  }

  return (
    <div>
      <div id={id} className="accommodation-page-container">
        <h1 className="m-fancy-text">Accommodation Options</h1>
        <p>
          The closest towns are <b>Nerac</b> and <b>Barbaste</b> - which are
          both within 10km of the venue and have a variety of hotels and B&Bs
        </p>
        <div className="booking-btn-container h-margin-top-big h-margin-bottom-big">
          <div className="booking-btn">
            <BookingDotComLink url={urls.nerac} text="Nerac" />
          </div>
          <div className="booking-btn">
            <BookingDotComLink url={urls.barbaste} text="Barbaste" />
          </div>
        </div>
        <div className="h-clear" />
        <p>
          Below is a list of recommended accomodation options that are all
          within a short cab ride from the venue
        </p>
        <AccommodationFilter />
        <AccommodationOptions />
      </div>
    </div>
  )
}

export default Accommodation



// WEBPACK FOOTER //
// ./src/components/Accommodation/Accommodation.js